import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FsLightbox from "fslightbox-react";
import winner1 from "../../../assets/winner_23/winner_1.jpg";
import runnerup1 from "../../../assets/winner_23/runnerup_1.jpg";
import winner2 from "../../../assets/winner_23/winner_2.jpg";
import runnerup2 from "../../../assets/winner_23/runnerup_2.jpg";
import winner3 from "../../../assets/winner_23/winner_3.jpg";
import runnerup3 from "../../../assets/winner_23/runnerup_3.jpg";
import winner4 from "../../../assets/winner_23/winner_4.jpg";
import winner5 from "../../../assets/winner_23/winner_5.jpg";
import runnerup5 from "../../../assets/winner_23/runnerup_5.jpg";
import winner6 from "../../../assets/winner_23/winner_6.jpg";
import runnerup6 from "../../../assets/winner_23/runnerup_6.jpg";
import winner7 from "../../../assets/winner_23/winner_7.jpg";
import winner8 from "../../../assets/winner_23/winner_8.jpg";
import winner9 from "../../../assets/winner_23/winner_9.jpg";
import winner10 from "../../../assets/winner_23/winner_10.jpg";
import winner11 from "../../../assets/winner_23/winner_11.jpg";
import winner12 from "../../../assets/winner_23/winner_12.jpg";
import winner13 from "../../../assets/winner_23/winner_13.jpg";

const photos = [
  {
    src: winner1,
    title: "Winner, Oby Ezekwesili Award (for Women Advocacy) ",
  },
  {
    src: runnerup1,
    title: "First Runner-up, Oby Ezekwesili Award (for Women Advocacy) ",
  },
  {
    src: winner2,
    title: "Winner, Award for Community Service",
  },
  {
    src: runnerup2,
    title: "First Runner-up, Award for Community Service",
  },
  {
    src: winner3,
    title: "Winner, Disability Advocacy / Empowerment Award",
  },
  {
    src: runnerup3,
    title: "First Runner-up, Disability Advocacy / Empowerment Award",
  },
  {
    src: winner4,
    title: "Winner, Solutions Journalism Award",
  },
  //   {
  //     src: winner4,
  //     title: "First Runner-up, Solutions Journalism Award",
  //   },
  {
    src: winner5,
    title: "Winner, Award for Civic Activism",
  },
  {
    src: runnerup5,
    title: "First Runner-up, Award for Civic Activism",
  },
  {
    src: winner7,
    title: "Winner, Award for Climate Change Activism",
  },
  {
    src: runnerup6,
    title: "First Runner-up, Award for  Climate Change Activism",
  },
  {
    src: winner8,
    title: "Winner, Award for Health Activism",
  },
  //   {
  //     src: winner8,
  //     title: "First Runner-up, Award for Health Activism",
  //   },
  {
    src: winner6,
    title: "Winner, Art for Activism",
  },
  {
    src: winner10,
    title: "Winner, Active Citizen Award",
  },
  {
    src: winner13,
    title: "Winner, Award for Institutional Transparency (Government Agencies)",
  },
  {
    src: winner11,
    title: "Winner, Corporate Award for Civic Investments - (For-Profit)",
  },
  {
    src: winner12,
    title: "Winner, Award for Inclusion & Diversity",
  },
  {
    src: winner9,
    title: "Winner, Hall of Fame Award for Civic Activism",
  },
];

const WinnerList = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box marginTop={{ xs: "25%", sm: "0%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"left"}
        flexWrap={"wrap"}
      >
        {photosToShow.map((item, index) => (
          <Box
            width={{ xs: "95%", sm: "23%" }}
            marginBottom={{ xs: "5%", sm: "2%" }}
          >
            <Box
              component="img"
              height={{ xs: "40vh", sm: "37vh" }}
              onClick={() => setIsViewerOpen(index)}
              sx={{
                width: "100%",
                borderRadius: 2,
                cursor: "pointer",
              }}
              src={item.src}
              alt={item.title}
            />
            <Box>
              <Typography
                variant={"body2"}
                fontWeight={500}
                color={"#049593"}
                textAlign="center"
              >
                {item.title}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <FsLightbox
        toggler={isViewerOpen}
        sources={[
          winner1,
          runnerup1,
          winner2,
          runnerup2,
          winner3,
          runnerup3,
          winner4,
          winner5,
          runnerup5,
          winner7,
          runnerup6,
          winner8,
          winner6,
          winner10,
          winner13,
          winner11,
          winner12,
          winner9,
        ]}
      />
    </Box>
  );
};

export default WinnerList;
